import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveLogo = function JoveLogo(props) {
  var width = props.width,
      height = props.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width || 31,
    height: height || 40,
    viewBox: "0 0 386 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M197.184 102.875V393.093C197.184 447.134 133.575 492.684 86.314 492.684V499.083C120.692 499.083 186.143 492.684 214.791 479.859C243.887 467.467 266.776 448.243 284.413 423.025C301.602 397.808 310.405 366.165 310.405 328.15V102.875C310.405 75.6512 316.135 52.8474 328.042 34.0295C339.472 15.6183 369.125 6.39917 385.419 6.39917V0H122.171V6.39917C138.465 6.39917 168.088 15.6183 179.547 34.0295C191.007 52.8474 197.184 75.6512 197.184 102.875Z",
      fill: "#202020"
    }), /*#__PURE__*/_jsx("path", {
      d: "M72.0709 445.129C111.402 445.129 143.286 414.933 143.286 377.685C143.286 340.437 111.402 310.241 72.0709 310.241C32.7397 310.241 0.855469 340.437 0.855469 377.685C0.855469 414.933 32.7397 445.129 72.0709 445.129Z",
      fill: "#0E35D1"
    })]
  });
};

var JoveLogoLoading = function JoveLogoLoading(props) {
  var label = props.label,
      className = props.className,
      labelClass = props.labelClass,
      _props$showMask = props.showMask,
      showMask = _props$showMask === void 0 ? true : _props$showMask,
      customMask = props.customMask,
      subTitle = props.subTitle,
      loadingTop = props.loadingTop,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size;
  var containerId = useRef(uniqueId());

  var _useState = useState(false),
      beyandRange = _useState[0],
      setBeyandRange = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    window.addEventListener('resize', adjustLoadingStyles);
    adjustLoadingStyles();
    return function () {
      return window.removeEventListener('resize', adjustLoadingStyles);
    };
  }, []);
  /**
   * methods
   */

  var adjustLoadingStyles = function adjustLoadingStyles() {
    var _window;

    var container = document.getElementById(containerId.current);
    setBeyandRange(!!(container !== null && container !== void 0 && container.offsetHeight) && (container === null || container === void 0 ? void 0 : container.offsetHeight) > ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight));
  };

  return /*#__PURE__*/_jsx("div", {
    style: {
      zIndex: 70
    },
    className: clsx("inset-0 left-0 top-0 flex h-full w-full justify-center backdrop-blur-xl", {
      absolute: !className,
      'bg-white/60': showMask && !customMask
    }, !loadingTop && !beyandRange ? 'items-center' : 'pt-[100px]', className),
    id: containerId.current,
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        marginTop: "".concat(loadingTop || 0)
      },
      className: "flex flex-col items-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: clsx('relative flex items-center justify-center', size === 'small' ? 'h-[40px] w-[40px]' : 'h-[80px] w-[80px]'),
        children: [/*#__PURE__*/_jsx("img", {
          className: "absolute h-full w-full",
          src: "https://storage.googleapis.com/jove-public-images/website/universal/gif_logo_loading.gif"
        }), /*#__PURE__*/_jsx(JoveLogo, {
          width: size === 'small' ? 15 : 30,
          height: size === 'small' ? 20 : 40
        })]
      }), label && /*#__PURE__*/_jsx("div", {
        className: clsx('mx-2 mt-1 text-center text-base font-bold', labelClass),
        children: label
      }), subTitle && /*#__PURE__*/_jsx("p", {
        className: "mt-2 text-center text-xs font-medium",
        children: subTitle
      })]
    })
  });
};

export default JoveLogoLoading;